'use strict';

/**
 * Moment Constants.
 * @readonly
 */
var TYPES = {
  DATE_TIME: {
    format: 'YYYY-MM-DDTHH:mm:ss.SSSZZ',
    local: false,
    time: false
  },
  LOCAL_DATE_TIME: {
    format: 'YYYY-MM-DDTHH:mm',
    local: true,
    time: false
  },
  LOCAL_DATE: {
    format: 'YYYY-MM-DD',
    local: true,
    time: false
  },
  LOCAL_TIME: {
    format: 'HH:mm',
    local: true,
    time: true
  }
};

/**
 * @readonly
 * @enum {TYPES}
 */
var FIELDS = {
  ADJUSTMENTS_HISTORY_DATE_TIME: TYPES.DATE_TIME,
  APPLICABLE_DATE_RANGE: TYPES.LOCAL_DATE,
  SELL_DATE_RANGE: TYPES.LOCAL_DATE,
  ARRIVAL_DATE: TYPES.LOCAL_DATE_TIME,
  ARRIVAL_TIME: TYPES.LOCAL_TIME,
  DEPARTURE_DATE: TYPES.LOCAL_DATE_TIME,
  DEPARTURE_TIME: TYPES.LOCAL_TIME,
  DASHBOARD_DATE: TYPES.LOCAL_DATE_TIME,
  RULE_DISCONTINUE_DATE: TYPES.DATE_TIME,
  RULE_EFFECTIVE_DATE: TYPES.DATE_TIME,
  RULE_CRITERIA_DATE: TYPES.LOCAL_DATE,
  RULE_CRITERIA_TIME: TYPES.LOCAL_TIME,
  OPT_GROUP_DATE: TYPES.LOCAL_DATE,
  ND_DEPARTURE_DATE: TYPES.LOCAL_DATE,
  MD_DEPARTURE_DATE: TYPES.LOCAL_DATE,
  COMPLETED_DATE: TYPES.DATE_TIME,
  CREATED_DATE: TYPES.DATE_TIME,
  CREATED_AT: TYPES.DATE_TIME,
  EVENT_TIME_STAMP: TYPES.DATE_TIME,
  EFFECTIVE_TIME_STAMP: TYPES.DATE_TIME,
  UPDATED_AT: TYPES.DATE_TIME,
  LAST_UPDATED_AT: TYPES.DATE_TIME,
  LAST_USED_AT: TYPES.DATE_TIME,
  LAST_RUN: TYPES.DATE_TIME,
  FARES_USAGE_DATE: TYPES.LOCAL_DATE,
  DATA_EXTRACT: TYPES.LOCAL_DATE_TIME,
  DATA_EXTRACT_APPLIED_FILTERS: TYPES.LOCAL_DATE,
  LAST_PROCESSED_DATE_TIME: TYPES.DATE_TIME,
  SEASONALITY_DATE_RANGE: TYPES.LOCAL_DATE_TIME,
  WEEK_START_DATE: TYPES.LOCAL_DATE_TIME,
  FORECAST_DATE: TYPES.DATE_TIME,
  SYSTEM_CONFIGURATION_DATE: TYPES.LOCAL_DATE,
  PRICING_DEPARTURE_DATE: TYPES.LOCAL_DATE,
  PRICING_DEPARTURE_TIME: TYPES.LOCAL_TIME,
  PRICING_SUMMARY_OPTIMIZATION_DATE: TYPES.LOCAL_DATE,
  PRICING_EXCLUSION_RULES_DATE: TYPES.LOCAL_DATE,
  FARE_EXCLUSION_RULES_DATE: TYPES.LOCAL_DATE,
  FARE_EXCLUSION_RULES_TIME: TYPES.LOCAL_TIME,
  HEP_LEG_ID_DEPARTURE_DATE: TYPES.LOCAL_DATE,
  HEP_PRICING_EXTRACT_NEXT_PROCESS_DATE: TYPES.LOCAL_DATE_TIME,
  PRICING_EFFECTIVE_TIME_STAMP: TYPES.LOCAL_DATE_TIME,
  PRICING_EVENT_TIME_STAMP: TYPES.LOCAL_DATE_TIME,
  TRAVEL_DATE: TYPES.LOCAL_DATE,
  OPTIMIZATION_RUN_DATE: TYPES.LOCAL_DATE
};

/**
 * @readonly
 * @enum {string}
 */
var FORMATS = {
  DATE: 'MM/DD/YYYY',
  TIME: 'hh:mm A',
  FULL_MONTH_YEAR_COMA_SEPARATED: 'MMMM, YYYY',
  FULL_MONTH_YEAR_SPACE_SEPARATED: 'MMMM YYYY',
  MONTH_SHORT_YEAR: 'MMM\'YY',
  MONTH: 'MMM',
  MONTH_FULL: 'MMMM',
  MONTH_DAY_YEAR: 'MMM D, YYYY',
  YEAR_MONTH_DAY_NOT_SEPARATED: 'YYYYMMDD',
  MONTH_DAY_YEAR_NOT_SEPARATED: 'MMDDYYYY',
  DATE_ISO: 'YYYY-MM-DD',
  DATE_ISO_REVERSE_NAMED_MONTH: 'DD-MMM-YYYY',
  DATE_TIME_ISO: 'YYYY-MM-DDTHH:mm:ss',
  DATE_TIME_ISO_WITHOUT_SECONDS: 'YYYY-MM-DDTHH:mm',
  DATE_TIME_MILLISECONDS_ISO: 'YYYY-MM-DDTHH:mm:ss.SSS',
  DATE_TIME_ISO_FILE_NAME: 'YYYY-MM-DDTHHmmss',
  DATE_HOURS_MINUTES: 'YYYY-MM-DD HH:mm',
  MM_DD_YYYY_HOURS_MINUTES_WITH_SLASHES: 'MM/DD/YYYY HH:mm',
  DATE_HOUR_MIN_WITH_SLASHES: 'YYYY/MM/DD HH:mm',
  USER_ACTION_DATE_TIME: 'MM/DD HH:mm',
  TIME_ISO: 'HH:mm',
  DAY_OF_WEEK: 'ddd',
  FULL_DAY_OF_WEEK: 'dddd',
  DAY_OF_MONTH: 'D',
  DAY_MONTH_SHORT_NAME: 'D|MMM',
  DAY_MONTH_SHORT_NAME_YEAR: 'D|MMM YYYY',
  DAY_MONTH_SHORT_NAME_SHORT_YEAR: 'D|MMM \'YY',
  MONTH_SHORT_NAME_DAY: 'MMM D',
  MONTH_SHORT_NAME_DAY_YEAR: 'MMM D, YYYY',
  MONTH_DAY: 'M/D',
  MONTH_YEAR: 'MMM YYYY',
  YEAR: 'YYYY',
  MONTH_DAY_YEAR_CALENDAR: 'MM/dd/yyyy',
  TIMESTAMP: 'x',
  DAY_MONTH_YEAR: 'dd/MM/yyyy',
  DAY_MONTH: 'DD/MM'
};
var RULE_TYPES = {
  'datetime': TYPES.DATE_TIME,
  '2datetime': TYPES.DATE_TIME,
  'date': TYPES.DATE_TIME,
  '2date': TYPES.DATE_TIME,
  'time': TYPES.LOCAL_TIME,
  '2time': TYPES.LOCAL_TIME,
  'utcdate': TYPES.LOCAL_DATE,
  'utc2date': TYPES.LOCAL_DATE
};
var MomentConstants = {
  FIELDS: FIELDS,
  TYPES: TYPES,
  FORMATS: FORMATS,
  RULE_TYPES: RULE_TYPES
};
module.exports = MomentConstants;